import React from 'react';

import { DataBlocks, I18n, Link } from 'components';

const SimTransferRequestStatus = () => (
  <DataBlocks.Block
    className="attention"
    title={<I18n path="home.simTransferRequestStatus.title" />}
  >
    <I18n path="home.simTransferRequestStatus.description" />
    <div>
      <Link href="/sim/">
        <I18n path="home.simTransferRequestStatus.linkText" />
      </Link>
    </div>
  </DataBlocks.Block>
);

export default SimTransferRequestStatus;
